import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { useState } from 'react';
import { Box, Switch } from "@mui/material"
import Button from 'react-bootstrap/Button'

const label = { inputProps: { 'aria-label': 'Size switch demo' } }

export const AddAdvertismentType = (props) => {
    const [isValidName, setIsValidName] = useState(true);


    const handleInputChange = (e, inputType) => {
        const value = e.target.value;
        // Simple validation: check if the input is not empty
        const isValidInput = value.trim() !== '';
        // Update the state based on validation result
        if (inputType === 'name') {
            setIsValidName(isValidInput);
        }
        props.setTypeFormData({
            ...props?.typeFormData,
            name: value
        })
    };

    return (
        <Modal
            {...props}
            size='lg'
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header>
                <Modal.Title id='contained-modal-title-vcenter'>
                    {props?.typeFormData?.uuid ? 'Update Type' : 'Add Type'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row'>
                    <div className='col-md-6'>
                        <Form.Group controlId='stateNameInput'>
                            <h4>Name*</h4>
                            <Form.Control
                                type='text'
                                placeholder='Enter Name'
                                value={props.typeFormData.name}
                                onChange={e => handleInputChange(e, 'name')}
                            />
                            {props?.typeFormData?.name === '' ? (
                                <label className='custom-error-label'>Name is required*</label>
                            ) : (
                                !isValidName && (
                                    <label className='custom-error-label'>
                                        Name is required.
                                    </label>
                                )
                            )}
                        </Form.Group>
                    </div>
                    <div className='col-md-3'>
                        <Form.Group controlId='parentIdInput'>
                            <h4>World Rate*</h4>
                            <Form.Control
                                type='text'
                                placeholder='World Rate'
                                value={props.typeFormData.worldValue}
                                onChange={e => handleInputChange(e, 'worldValue')}
                            />
                        </Form.Group>
                    </div>
                    <div className='col-md-3'>
                        <Form.Group controlId='parentIdInput'>
                            <h4>Link Enable*</h4>
                            <Switch
                                {...label}
                                checked={props.typeFormData?.linkEnable}
                                onChange={(e) =>
                                    props?.setTypeFormData({
                                        ...props.typeFormData,
                                        linkEnable: e?.target?.checked
                                    })
                                }
                                size='small'
                            />
                        </Form.Group>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='outline-secondary' onClick={props.onHide}>Cancel</Button>
                <Button variant='primary' onClick={() => props?.onSubmit()}>Submit</Button>
            </Modal.Footer>
        </Modal>
    );
}